import store from '@/stores/index';

export const getListeningState:any = () => {
  return store.getState().listening;
};

export interface ILQuestionDetail {
  // global id
  id: number;
  // question number
  number: number;
  // 题目内容
  title: string;
  option: any[];

  // 题目解析
  analyze: Array<{ type: string; content: string; location: any; }>;

  // 定位词
  locating_words: Array<{
    locating_word: string;
    syn_ary: Array<{
      synonym: string;
      target_sen: Array<{
        index: number;
        length: number;
        lyc_index: number;
        target_sen: string;
      }>;
    }>;
  }>;

  // 答案句
  answer_sentences: {
    lyc_index: number[];
    start_time: number;
    end_time: number;
  };

  // 本地对应的音频时间
  start_time: number;
  end_time: number;

  display_answer: string;
  ai_analyze: string;
}

export const forEachListeningQuestion = (callback: (q: ILQuestionDetail) => void) => {
  const originData = (store.getState() as any).listening.pageData.question;
  if (!originData) {
    return;
  }

  for (const group of originData.question) {
    for (let i = 0; i < group.list.length; ++i) {
      const q = group.list[i];
      callback(q);
    }
  }
};

